import * as yup from 'yup';
import {
  addressLine1,
  addressLine2,
  birthDate,
  city,
  country,
  email,
  firstName,
  lastName,
  phone,
  phoneCountryCode,
  postalCode,
  state,
} from 'utils/schemaUtils';

export default yup.object({
  addressLine1,
  addressLine2,
  birthDate,
  city,
  country,
  email,
  firstName,
  lastName,
  phone,
  phoneCountryCode,
  postalCode,
  state,
});
